module.exports = __webpack_public_path__ + "img/loons_06.ea523f73.png";